import React from 'react'
import { useRecoilValue } from 'recoil'
import { useIntl } from 'react-intl'
import { useStorage } from 'Hooks/'
import PropTypes from 'prop-types'

import {
  Panel,
  MessageBox,
  SpacingVertical,
  SPACING_16
} from 'mailup-web-components'
import { ContentScheduled } from 'Components/ContentScheduled/ContentScheduled'

import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

import { STORE_KEY_LIST } from 'Constants'

const BoxDate = ({ scheduleDate, scheduleTimeZoneCode }) => {
  const { step4 } = useRecoilValue(abTestState)

  const intl = useIntl()

  const [{ TimeZoneCode: listTimeZoneCode }] = useStorage(STORE_KEY_LIST).values

  return (
    <>
      <Panel collapsible={false}>
        <ContentScheduled
          scheduleDate={scheduleDate}
          scheduleTimeZoneCode={scheduleTimeZoneCode || listTimeZoneCode}
          dateDisabled={!step4.loaded}
          hoursDisabled={!step4.loaded}
          minutesDisabled={!step4.loaded}
          timeZoneDisabled={!step4.loaded}
        />
        {/* si vede solo quando ha finito il loading */}
        {!step4.loaded && (
          <>
            <SpacingVertical variant={SPACING_16} />
            <MessageBox>
              {intl.formatMessage({
                id: 'Load.ABTestWizard.InfoSchedulingStopped'
              })}
            </MessageBox>
          </>
        )}
      </Panel>
    </>
  )
}

BoxDate.propTypes = {
  scheduleDate: PropTypes.any,
  scheduleTimeZoneCode: PropTypes.any
}

export default BoxDate
